// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2zw6R","content":"Header_content__2F442","text":"Header_text__8a9ml","action":"Header_action__3P7sq","large":"Header_large__sca7F"};